// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_2bKEN","hidden":"_3f4je","buttonWrapper":"_8X58X","downloadButton":"_1Qr0S","icon_small":"xDOGF","iconSmall":"xDOGF","icon_big":"_1wSBb","iconBig":"_1wSBb"};